import {
  PermissionTableOperation,
  PermissionsTableRow,
} from '@modules/users/types';
import { getPermissionTableOperation } from '@modules/users/utils';
import { UserType, UserTypeWithPermissions } from 'generated/graphql';

export const getPermissionsRows = (
  permissionsData: UserTypeWithPermissions[] | undefined,
): PermissionsTableRow[] => {
  if (!permissionsData) {
    return [];
  }

  const permissionsByRolesMap = new Map<
    PermissionsTableRow['module'],
    Pick<PermissionsTableRow, 'adminOperation' | 'memberOperation'>
  >();

  permissionsData.forEach((data) => {
    if (data.type === UserType.Manager || data.type === UserType.Editor) {
      data.permissions?.forEach((permission) => {
        const { resource, operation } = permission;

        const roles = permissionsByRolesMap.get(resource) ?? {
          adminOperation: PermissionTableOperation.None,
          memberOperation: PermissionTableOperation.None,
        };

        if (data.type === UserType.Manager) {
          roles.adminOperation = getPermissionTableOperation(operation);
        } else if (data.type === UserType.Editor) {
          roles.memberOperation = getPermissionTableOperation(operation);
        }

        permissionsByRolesMap.set(resource, roles);
      });
    }
  });

  return Array.from(permissionsByRolesMap.entries()).map(([module, roles]) => ({
    module,
    ...roles,
  }));
};
